const PayrollNavData = [
    { id: "section1", name: "Contribution" },
    { id: "section2", name: "Minimum Wage" },
    { id: "section3", name: "Payroll" },
    { id: "section4", name: "Working Hours" },
    { id: "section5", name: "Leave" },
    { id: "section6", name: "Termination" },
    { id: "section7", name: "VAT" },
  ];
  
  export default PayrollNavData;